/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './modal';
import './modal-body';
import './modal-close-button';
import './modal-footer';
import './modal-footer-button';
import './modal-header';
import './modal-heading';
import './modal-label';
